import { getFormDefinition, createFormDataFromItem, createItemFromFormData } from './form';
import { entityToStore } from '@/utils/store';
import baseCrudMixin from '@/mixins/crud';
export default {
  computed: {
    definition() {
      return this.createDefinition();
    },
    entityStore() {
      return entityToStore(this.entity);
    }
  },
  mixins: [baseCrudMixin],
  data: () => ({
    entity: 'Company',
    returnTo: 'Companies'
  }),
  created() {
    this.$store.dispatch('company/getItems');
    this.$store.dispatch('country/getItems');
    this.$store.dispatch('transportCompany/getItems');
    this.$store.dispatch('currency/getItems');
    this.$store.dispatch('exactInstance/getItems');
  },
  methods: {
    createDefinition() {
      return getFormDefinition(this);
    },
    createFormDataFromItem,
    createItemFromFormData
  }
};
